import { Caption, Div } from '@vkontakte/vkui';
import React from 'react';
import packageJson from '../../../package.json';
import { useAppContext } from '../../AppContext';

export const AppVersionComponent = ({}) => {
  const context = useAppContext();
  const version = (process.env.NODE_ENV === 'development' ? 'dev ' : '') + process.env.REACT_APP_PLATFORM_TYPE + ':' + packageJson.version;

  return (<Div>
    <Caption level={'1'}>{context.lang().getKey('app', 'client_version', '', {version})}</Caption>
  </Div>);
}